import { useState } from 'react';
import { Box, Typography, type Theme } from '@mui/material';
import { Rating } from '@care/react-component-lib';
import { CaregiverSearchResultFields_caregiverSearchResults_caregiverReviews as CaregiverReviews } from '@/__generated__/CaregiverSearchResultFields';
import { ProviderSearchResultFields_providerSearchResults_providerReviews as ProviderReviews } from '@/__generated__/ProviderSearchResultFields';
import { AmplitudeEvent, trackAmplitudeEvent, SeoFeatureInteracted } from '@/lib/analyticsHelper';
import ReadMore from '@/components/ReadMore';

interface RobustProfileReviewProps {
  reviews: CaregiverReviews[] | ProviderReviews[];
}

const RobustProfileReview = ({ reviews }: RobustProfileReviewProps) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const amplitudeTrackingForShowMoreReview = () => {
    const amplitudeData: SeoFeatureInteracted = {
      feature_name: 'Show More Review Content',
    };

    trackAmplitudeEvent(AmplitudeEvent.seoFeatureInteracted, amplitudeData);
  };

  const handleShowMoreReviewClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    const target = e.target as HTMLAnchorElement;
    if (target.tagName.toLowerCase() === 'button') {
      setIsExpanded(!isExpanded);
      if (!isExpanded) {
        amplitudeTrackingForShowMoreReview();
      }
    }
  };

  return (
    <>
      {reviews.map((review, index) => (
        <Box key={`${review.reviewer.displayName}-${index + 1}`}>
          <Box
            mt={3}
            p={2}
            component="div"
            sx={(theme: Theme) => ({
              borderRadius: '16px',
              border: `1px solid ${theme.palette.care.grey[400]}`,
            })}>
            {!!review.rating && (
              <Box>
                <Box display="block" whiteSpace="nowrap">
                  <Rating name="size-medium" size="small" defaultValue={review.rating} readOnly />
                </Box>
              </Box>
            )}

            <Box mt={1} component="div">
              {review.comment && (
                <Box>
                  <ReadMore
                    gutterBottom
                    color="textPrimary"
                    component="div"
                    variant="body2"
                    charLimit={265}
                    value={review.comment || ''}
                    showMoreLabel="show more"
                    showDoubleQuotes
                    onClick={(e: React.MouseEvent<HTMLAnchorElement>) =>
                      handleShowMoreReviewClick(e)
                    }
                  />
                </Box>
              )}
              <Box mt={1}>
                <Typography variant="body2">
                  <span style={{ fontWeight: 700 }}>
                    {review.reviewer.displayName || 'Care member'}
                  </span>
                </Typography>
              </Box>
            </Box>
          </Box>
        </Box>
      ))}
    </>
  );
};

export default RobustProfileReview;
